import { useState } from 'react';
import { useHistory } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { Button, CustomDialog } from 'web-library';
import { useGetValidateNonNationalExamVacancy } from '../../../api-refactored/non-national-exam-registration/useGetValidateNonNationalExamVacancy';
import { usePutResetNonNationalVacancyPaymentExpiry } from '../../../api-refactored/non-national-exam-registration/usePutResetNonNationalVacancyPaymentExpiry';
import RouteKey from '../../../routes/key';

interface VacancyExpiredModalProps {
  uuid: string;
  openModal?: boolean; // For open modal without calling validate API
}

const { exam } = RouteKey.child;
const { examRegistrations, nonNationalExaminations } = RouteKey.exam.child;

/**
 *  This modal can only be used in non-national exam registration flow
 *  It is highly dependent on the url path to get the examType for redirecting
 */
const VacancyExpiredModal = ({ uuid, openModal = false }: VacancyExpiredModalProps) => {
  const { t } = useTranslation();
  const history = useHistory();
  const [isVacancyExpired, setIsVacancyExpired] = useState(false);
  const examType = history.location.pathname.split('/')[5];

  useGetValidateNonNationalExamVacancy({
    uuid,
    enabled: !openModal,
    onError: () => {
      setIsVacancyExpired(true);
    },
  });

  const { mutate, isLoading } = usePutResetNonNationalVacancyPaymentExpiry({
    uuid,
    // using onSettled here to redirect candidate regardless of API success or fail
    onSettled: () => {
      history.push(
        `/${exam}/${examRegistrations.route}/${nonNationalExaminations.route}/${examType}`
      );
    },
  });

  const resetVacancyPaymentExpiry = () => {
    mutate();
  };

  return (
    <CustomDialog
      state="error"
      dialogSize="sm"
      open={isVacancyExpired || openModal}
      stateText={t('exam->>NonNationalExam.RegistrationVacancyExpired')}
      message={t('exam->>NonNationalExam.RegistrationVacancyExpiredMessage')}
      action={
        <Button
          type="button"
          variant="text"
          color="primary"
          isLoading={isLoading}
          onClick={resetVacancyPaymentExpiry}
        >
          {t('exam->>NonNationalExam.BackToRegisterExam')}
        </Button>
      }
    />
  );
};

export default VacancyExpiredModal;
